import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAnimationNone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"animation-none"} maskId="square-filled-radius-0-stroke-1-IconAnimationNone"><path fillRule="evenodd" clipRule="evenodd" d="M11.5 3H21V4H12.5V21H3V20H11.5V3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconAnimationNone;
